import { RequirementResult } from './types';

/** Grenene et krav kan ha barn i. */
export type BranchKind = 'allOf' | 'anyOf' | 'oneOf' | 'not';

export type RequirementBranchData = {
  kind: BranchKind;
  items: RequirementResult[];
};

/** Tekstnøkkel for hver gren — «alle av disse», «én av disse veiene», «ingen av disse». */
export const BRANCH_MESSAGE_IDS: { [key in BranchKind]: string } = {
  allOf: 'certreq.branch.allof',
  anyOf: 'certreq.branch.anyof',
  oneOf: 'certreq.branch.oneof',
  not: 'certreq.branch.not',
};

/**
 * Sorterer søsken på `order` når det er satt. Krav uten `order` beholder
 * rekkefølgen fra motoren, og legges etter de sorterte.
 */
export const sortRequirements = (items: RequirementResult[]): RequirementResult[] => {
  return items
    .map((item, index) => ({ item, index }))
    .sort((a, b) => {
      const aOrder = typeof a.item.order === 'number' ? a.item.order : Number.MAX_SAFE_INTEGER;
      const bOrder = typeof b.item.order === 'number' ? b.item.order : Number.MAX_SAFE_INTEGER;
      if (aOrder !== bOrder) return aOrder - bOrder;
      return a.index - b.index;
    })
    .map((entry) => entry.item);
};

/** Grenene på ett krav, i fast rekkefølge og uten tomme grener. */
export const getBranches = (result: RequirementResult): RequirementBranchData[] => {
  const branches: RequirementBranchData[] = [];
  if (result.allOf?.length) branches.push({ kind: 'allOf', items: sortRequirements(result.allOf) });
  if (result.anyOf?.length) branches.push({ kind: 'anyOf', items: sortRequirements(result.anyOf) });
  if (result.oneOf?.length) branches.push({ kind: 'oneOf', items: sortRequirements(result.oneOf) });
  if (result.not) branches.push({ kind: 'not', items: [result.not] });
  return branches;
};

/** Et krav uten grener er et blad — det er der dokumentasjon hører hjemme. */
export const isLeafRequirement = (result: RequirementResult): boolean =>
  getBranches(result).length === 0;

/** Utelatt `documentable` betyr TRUE. Bare eksplisitt false slår av opplasting. */
export const isDocumentable = (result: RequirementResult): boolean => result.documentable !== false;
